/**
 * Ukrainian UI copy glossary — verbatim from AGENTS.md §7. This is the single source of
 * truth for user-facing strings; docs/ukrainian-copy.md is a human-readable mirror of this
 * file, kept in sync manually. If a new string is needed, add it here AND to that doc in
 * the same PR (per AGENTS.md §7's closing rule) — do not retranslate existing entries.
 */
export const copy = {
  nav: {
    dashboard: "Дашборд",
    orders: "Воронка",
    reminders: "Нагадування",
    clients: "Клієнти",
    leads: "Розсилка",
    reports: "Звіт",
  },
  logout: "Вийти",
  login: {
    title: "Вхід до CRM",
    loginField: "Логін",
    passwordField: "Пароль",
    submit: "Увійти",
  },
  newOrderButton: "+ Нове замовлення",
  orderStatus: {
    new: "Новий",
    in_progress: "В роботі",
    done: "Виконано",
    rejected: "Відмова",
  },
  productLine: {
    wheels: "Диски",
    steering_wheels: "Рулі",
    all: "Все разом",
  },
  rejectReason: {
    price: "Відмова",
    not_relevant: "Передумали",
  },
  leadsCategory: {
    price: "Відмова",
    not_relevant: "Передумали",
    placed: "Розмістили замовлення",
  },
  table: {
    date: "Дата",
    status: "Статус",
    client: "Клієнт",
    phone: "Телефон",
    carWheel: "Авто / Диск",
    comment: "Коментар",
  },
  field: {
    wheelSize: "Розмір диска",
    carBrand: "Марка авто",
    carBrandYear: "Марка авто, рік випуску",
    carYear: "Рік випуску авто",
    source: "Джерело",
    purchasePrice: "Ціна закупівлі, $",
    salePrice: "Ціна продажу, $",
    orderValue: "Вартість замовлення, $",
    costPrice: "Собівартість, $",
    prepayment: "Передоплата, $",
    extraSales: "Дод. товари/послуги, $",
    deliveryCost: "Вартість доставки, $",
    operatorComment: "Коментар оператора",
    orderComment: "Коментар по замовленню",
    rejectReasonLabel: "Причина відмови",
  },
  source: {
    site: "Сайт",
    phone: "Дзвінок",
    instagram: "Instagram",
    telegram: "Telegram",
  },
  reminders: {
    date: "Дата",
    time: "Час (робочий, 09:00–19:00)",
    note: "Замітка",
    defaultNote: "Передзвонити клієнту",
    preset2: "Забрати замовлення",
    preset3: "Запитати, що вирішив",
    markDone: "Готово",
    tabActive: "Активні",
    tabDone: "Виконані",
    tabAll: "Всі",
    badgeOverdue: "Прострочено",
    badgeToday: "Сьогодні",
  },
  save: "Зберегти",
  cancel: "Скасувати",
  back: "Назад",
  dashboard: {
    statNew: "Нових за місяць",
    statInProgress: "В роботі",
    statDone: "Виконано",
    statRejected: "Відмов",
    hotWidget: "🔥 Гарячі замовлення",
    remindersWidget: "Нагадування на найближчі дні",
  },
  emptyState: "Тут поки що порожньо",
  leads: {
    title: "Розсилка",
    downloadButton: "Скачати .csv",
  },
  reports: {
    title: "Звіт",
    revenue: "Виручка, $",
    extraSales: "Дод. продажі",
    cost: "Собівартість, $",
    delivery: "Доставка, $",
    profit: "Прибуток, $",
    topBrands: "Топ марок авто",
    sendToTelegram: "Надіслати в Telegram",
    expensesTitle: "Витрати",
    expensesTotal: "Витрати, $",
    netProfit: "Чистий прибуток, $",
    saveExpenses: "Зберегти витрати",
    adSpend: "Реклама, $",
    netProfitAfterAds: "Прибуток після реклами, $",
    dateBasisCreated: "По даті заявки",
    dateBasisCompleted: "По даті виконання",
  },
  expenseField: {
    rent: "Оренда, $",
    salary: "ЗП, $",
    taxes: "Податки, $",
    materials: "Матеріали, $",
    utilities: "Комуналка, $",
  },
  clients: {
    title: "Клієнти",
    searchPlaceholder: "Пошук за іменем або телефоном",
    orderCountColumn: "Замовлень",
    lastOrderColumn: "Останнє замовлення",
  },
} as const;
